<template>

  <div ref="formStep" class="form-step" data-step="2">
    <div>
      <div ref="dynamicSpeechBubble" class="dynamicspeechbubble bubble2">
        <p>{{ $t('formContent.Step4form_intro1') }} <br/>{{ $t('formContent.Step4form_intro2') }}</p>
      </div>
      <div ref="contentWrapper" class="form-step-contentwrapper">
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <swiper-container class="swipercontainer transport-slider"
                              ref="swiperContainer"
                              :slide-to-clicked-slide="true"
                              :slides-per-view="3"
                              :centered-slides="false"
                              :initialSlide="1"
                              :autoHeight="true"
                              :pagination="{
                                hideOnClick: false,
                                clickable:true
                              }"
                              :breakpoints="{
                                300:  {
                                  slidesPerView: 1,

                                  },
                                1025:  {
                                  slidesPerView: 3,

                                  },
                              }"


                              @swiperprogress="onProgress"

                              @swiperclick="onClick"
            >

              <swiper-slide data-transport="plane">
                <div class="imgwrapper">
                  <img src="@/assets/img/transport_plane.png">
                  <div class="showactive previousstep">
                    <div class="speechbubble">{{ $t('formContent.Step4form_bubble1') }}
                      <div @click="$emit('previous')">
                        <img :src="selectedImage">
                      </div>

                    </div>
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide data-transport="car">
                <div class="imgwrapper">
                  <img src="@/assets/img/transport_car.png">
                  <div class="showactive previousstep">
                    <div class="speechbubble">{{ $t('formContent.Step4form_bubble2') }}
                      <div @click="$emit('previous')">
                        <img :src="selectedImage">
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide data-transport="train">
                <div class="imgwrapper">
                  <img src="@/assets/img/transport_train.png">
                  <div class="showactive previousstep">
                    <div class="speechbubble">{{ $t('formContent.Step4form_bubble3') }}
                      <div @click="$emit('previous')">
                        <img :src="selectedImage">
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>

            </swiper-container>
            <input
                name="chosenAvatar"
                type="hidden"
                v-model="localFormData.transport"
            />
          </div>
          <div>
            <button
                :class="{ 'disabled': isButtonDisabled }"
                type="submit"
                class="button marginauto nextstep">
              <span>{{$t('formContent.Step4form_button')}}</span><img src="@/assets/img/arrow-right.svg"/>
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>

</template>

<script>
/* eslint-disable */
import {register} from 'swiper/element/bundle';
import {gsap} from "gsap";

register();

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Übertragen der aus setup() stammenden reaktiven Daten
      spaceBetween: 10,
      localFormData: JSON.parse(JSON.stringify(this.formData)),
      dynamicSpeechBubble: null,
      swiperContainer: null,
      formContent: null,
      contentWrapper: null,
      formStep: null,
      selectedImage: null
    };
  },
  mounted() {
    this.initAnimations();
    this.updateImage(this.formData.avatar);
  },
  computed: {
    isButtonDisabled() {
      return !this.localFormData.transport || this.localFormData.transport.length === 0;
    }
  },
  methods: {
    submitForm() {
      this.$emit('update', this.localFormData);
      this.$emit('next');
      //this.$emit('form-submitted');
    },
    onProgress(e) {
      const [swiper, progress] = e.detail;
    },
    onClick(swiper) {
      // Zugriff auf alle Slides im Swiper
      const slides = swiper.detail[0].slides;


      // Entfernen der Klasse "deine-neue-klasse" von allen Slides
      slides.forEach((slide) => {
        slide.classList.remove('activeSlide');
      });

      // Zugriff auf das geklickte Slide
      const clickedSlide = swiper.detail[0].clickedSlide;

      // Hinzufügen der Klasse "deine-neue-klasse" zum geklickten Slide
      if (clickedSlide) {
        clickedSlide.classList.add('activeSlide');
        this.localFormData.transport = swiper.detail[0].clickedSlide.dataset.transport;
      }
    },
    initAnimations() {
      const splitTextTimeline = gsap.timeline();
      splitTextTimeline.fromTo(this.$refs.dynamicSpeechBubble, {display: "none", autoAlpha: 0, y: -100}, {
        autoAlpha: 1,
        display: "block",
        y: 0
      });
      splitTextTimeline.fromTo(this.$refs.contentWrapper, {delay: 2, autoAlpha: 0}, {autoAlpha: 1});
      splitTextTimeline.fromTo(this.$refs.swiperContainer, {delay: 2, autoAlpha: 0}, {autoAlpha: 1});
      this.$refs.swiperContainer.swiper.slideNext();
    },
    updateImage(avatar) {
      this.selectedImage = require(`@/assets/img/avatare/${avatar}.webp`);
    },
  },
};
</script>

<style lang="scss">
.swipercontainer {
  width: 100%;
  max-width:100% !important;
}
.transport-slider {
  :root & {

    --swiper-pagination-left: auto;
    --swiper-pagination-right: 8px;
    --swiper-pagination-bottom: 0px;
    --swiper-pagination-top: auto;

    --swiper-pagination-bullet-horizontal-gap: 4px;
    --swiper-pagination-bullet-vertical-gap: 6px;
  }
}
</style>

<style lang="scss" scoped>
.form-step {
  display: flex !important;
}

.form-step {
  width: 80%;
  max-width: 80%;
  @media screen and (max-width:640px) {
    max-width: 100%;
    width: 100%;
  }

  > div {
    width: 100%;
  }
}


swiper-slide {
  text-align: center;
  cursor:pointer;
}


.imgwrapper {
  text-align: center;
  margin: auto;
  width: 100%;
  padding-top: 20px;
  img {
    &:hover {
      transform: scale(1);
      transition: 1s;
    }
  }
}


.activeSlide {
  .speechbubble {
    text-align:left;
    @media screen and (max-width:768px) {
      font-size:18px;
    }
    @media screen and (max-width:768px) {
      box-shadow: 0px 0px 23px rgba(0, 0, 0, 0.51);
    }
  }
  .imgwrapper img {
    transform: scale(1);
    transition: 1s;
  }
}



.imgwrapper img {
  width: 100% !important;
  margin: auto;
  transform: scale(0.7);
  transition: 1s;
  height:auto !important;
  @media screen and (max-width:768px) {
    transform:scale(1);
  }
}


</style>
